import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AsyncPaginate } from "react-select-async-paginate";

const FetchServiceList = (props) => {
  const [serviceComponentId, setServiceComponentId] = useState('');
  const [subServiceComponentId, setSubServiceComponentId] = useState('');
  const queryParams = new URLSearchParams(window.location.search);
  const accessToken = queryParams.get("userAuthToken");

  useEffect(() => {
    setServiceComponentId(props.currentSystemId);
    setSubServiceComponentId(props.currentSubSystemId);
  }, [props.currentSystemId, props.currentSubSystemId])

  const loadOptions = async (searchQuery, _, { page }) => {

    const response = await fetch(
      `/api/v1/service_codes/aar/services?sub_service_component=${subServiceComponentId ? subServiceComponentId : ''}&service_component=${serviceComponentId ? serviceComponentId : ''}&search=${searchQuery}&page=${page}`, {
      method: 'GET',
      headers: {
        'Access-Token': accessToken,
      },
    }
    );
    const responseJSON = await response.json();

    let options = responseJSON.services.map((option) => ({
      label: `${option.name}`,
      value: `${option.id}`,
      data: option
    }))

    return {
      options: options,
      hasMore: responseJSON.meta.has_more,
      additional: {
        page: page + 1,
      },
    };
  };

  const onChange = (option) => {
    if (typeof props.onChange === "function") {
      props.onChange(option);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: '#fff',
      borderColor: props.showError ? '#ff0000' : '#cccccc',
    }),
  };

  return (
    <>
      { typeof (props.value) === 'string' ?
        <AsyncPaginate
          key={JSON.stringify(subServiceComponentId)}
          defaultValue={{ value: props.value, label: props.value }}
          loadOptions={loadOptions}
          onChange={onChange}
          isSearchable={true}
          placeholder="Please select"
          className='service_dropdown async-dd'
          isClearable={true}
          debounceTimeout={500}
          additional={{
            page: 1,
          }}
        /> :

        <AsyncPaginate
          key={JSON.stringify(subServiceComponentId)}
          value={props.value}
          loadOptions={loadOptions}
          onChange={onChange}
          isSearchable={true}
          placeholder="Please select"
          className='service_dropdown async-dd'
          styles={customStyles}
          isClearable={true}
          debounceTimeout={500}
          additional={{
            page: 1,
          }}
        />
      }
    </>
  );
};

FetchServiceList.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  currentSubSystemId: PropTypes.number
};

export default FetchServiceList;
